import { render, staticRenderFns } from "./MeetingSlotLabel.vue?vue&type=template&id=cd4e2a4a&scoped=true"
import script from "./MeetingSlotLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingSlotLabel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MeetingSlotLabel.vue?vue&type=style&index=0&id=cd4e2a4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4e2a4a",
  null
  
)

export default component.exports